import React from 'react';    

export const ChequeCultureLegacy  = () => {
    return <div>
        <link rel="stylesheet" type="text/css" href="../layout/styles/bootstrap-table.css"/>    
                    <link rel="stylesheet" type="text/css" href="../layout/styles/bootstrap-select.min.css"/>
                    <link rel="stylesheet" href="https://cdn.cgos.info/cgosBar/css/cgos.bar.3.2.min.css"/>
                    <link rel="stylesheet" href="https://cdn.cgos.info/assets/css/app.1.1.min.css" media="screen"/>
                    <link rel="stylesheet" href="https://cdn.cgos.info/assets/stylesheets/www-print.css" media="print"/>
                    <link rel="stylesheet" href="//code.jquery.com/ui/1.11.4/themes/smoothness/jquery-ui.css"/>
                    <link rel="stylesheet" href="https://fr.rakko.tools/tools/129/lib/tinymce/skins/content/default/content.min.css"/>
                    <link rel="stylesheet" href="https://agent.cgos.info/agent/style/infobulle.css"></link>
                    <link rel="stylesheet" type="text/css" href="../layout/styles/inline-cgos.css"/>
                    <link rel="stylesheet" type="text/css" href="https://agent.cgos.info/agent/style/agent.css"/>
                    <link rel="stylesheet" type="text/css" id="u0" href="https://fr.rakko.tools/tools/129/lib/tinymce/skins/ui/oxide/content.min.css"/>
                    <link rel="stylesheet" type="text/css" id="u1" href="https://fr.rakko.tools/tools/129/lib/tinymce/skins/content/default/content.min.css"/>
    </div>
}
